"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToUnixTimestamp = exports.getCurrTimestampNumber = exports.unixTimestampToDate = exports.isUnixTimestampExpired = exports.getDateFormatDayMonthYear = exports.monthNames = void 0;
exports.monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];
function getDateFormatDayMonthYear() {
    const d = new Date();
    return d.getUTCDate() + exports.monthNames[d.getUTCMonth()] + d.getUTCFullYear();
}
exports.getDateFormatDayMonthYear = getDateFormatDayMonthYear;
function isUnixTimestampExpired(timestamp) {
    return new Date(timestamp * 1000) < new Date();
}
exports.isUnixTimestampExpired = isUnixTimestampExpired;
function unixTimestampToDate(timestamp) {
    return new Date(Number(timestamp) * 1000).toISOString().split('T')[0]; // return date with "YYYY-mm-dd" format
}
exports.unixTimestampToDate = unixTimestampToDate;
function getCurrTimestampNumber() {
    return Math.round(Date.now() / 1000);
}
exports.getCurrTimestampNumber = getCurrTimestampNumber;
//returns seconds between 1/1/1970 to given date
function dateToUnixTimestamp(date) {
    if (!date)
        return;
    return Math.floor(date.getTime() / 1000);
}
exports.dateToUnixTimestamp = dateToUnixTimestamp;
//# sourceMappingURL=dates.js.map